import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/about`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer les informations 'about'
export const getAboutInfo = async () => {
  try {
    const response = await axios.get(`${apiUrl}/aboutInfo`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  }
  catch (error) {
    console.error("Erreur lors du chargement des informations 'about':", error);
    return {}; // Renvoie un objet vide en cas d'échec pour maintenir la cohérence du type de retour
  }
}

/// PUT
// Fonction pour mettre à jour les informations 'about'
export const updateAboutInfo = async (updatedInfo) => {
  try {
    const response = await axios.put(`${apiUrl}/updateAboutInfo`, updatedInfo, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to update 'about' info");
    return response.data; // Renvoie directement les données
  }
  catch (error) {
    console.error("Erreur lors de la mise à jour des informations 'about':", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
}

/// POST
export const uploadParcoursImage = async (formData) => {
  try {
    const response = await axios.post(
      `${apiUrl}/photoParcours`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          "x-category": "about",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image du parcours :", error);
    return null;
  }
};


export const uploadProjetImage = async (formData) => {
  try {
    const response = await axios.post(
      `${apiUrl}/photoProjet`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          "x-category": "about",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image du projet :", error);
    return null;
  }
};



